/**
 * Acuerdos-Con-Gestores API
 * Acuerdos-Con-Gestores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConsentimientoEstadosDTO } from './consentimientoEstadosDTO';
import { PoseedorDTO } from './poseedorDTO';
import { CodigoLerDTO } from './codigoLerDTO';
import { DocumentoDTO } from './documentoDTO';
import { AcuerdoIndirectoDTO } from './acuerdoIndirectoDTO';


export interface ConsentimientoDTO { 
    id?: number;
    acuerdoIndirecto?: AcuerdoIndirectoDTO;
    fechaBaja?: string;
    usuarioBaja?: string;
    codigoDocumento?: string;
    estado?: ConsentimientoEstadosDTO;
    documentoPendienteFirma?: DocumentoDTO;
    documentoFirmado?: DocumentoDTO;
    fechaFirmaAcuerdo?: string;
    razonSocial?: string;
    tipoDocumentoFirmante?: ConsentimientoDTO.TipoDocumentoFirmanteEnum;
    codigoDocumentoFirmante?: string;
    nombreFirmante?: string;
    apellidosFirmante?: string;
    poseedores?: Array<PoseedorDTO>;
    codigoLer?: Array<CodigoLerDTO>;
}
export namespace ConsentimientoDTO {
    export type TipoDocumentoFirmanteEnum = 'NIF' | 'DNI' | 'NIE';
    export const TipoDocumentoFirmanteEnum = {
        Nif: 'NIF' as TipoDocumentoFirmanteEnum,
        Dni: 'DNI' as TipoDocumentoFirmanteEnum,
        Nie: 'NIE' as TipoDocumentoFirmanteEnum
    };
}


